<template>
    <component :is="component" :filterData="filterData" v-if="component" :areaList="areaList" />
</template>

<script>
    export default {
        name: "MemberFilterLink",
        mixins: [],
        components: {
        },
        props: {
            filterLayout: {},
            filterData: {
                default: {}
            },
            areaList:{
                type: Array,
                default: () => {return []}
            },
        },
        data() {
            return {
                component: null,
            }
        },
        beforeRouterEnter() {},
        created() {
        },
        mounted() {
            this.filterLoader();
        },
        beforeDestroy() {
        },
        destroyed() {},
        computed: {
            loader() {
                if (!this.filterLayout) {
                    return null
                }
                return () => import(`@/template/member/filter/${this.filterLayout}`)
            },
        },
        methods: {
            filterLoader() {
                this.loader()
                    .then(() => {
                        this.component = () => this.loader()
                    })
                    .catch(() => {
                        this.component = () => import('@/template/member/filter/MemberFilterDefaultLayout')
                    })

            },
        },
        watch: {
            'filterLayout': {
                deep: true,
                handler: function () {
                    this.filterLoader();
                }
            }
        },
    }
</script>

<style scoped>

</style>